import type { AssetTheoricalRemainingLifespanProps } from "./asset-theorical-remaining-lifespan.type";

import { CalendarOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

import { getAssetTheoricalRemainingLifespan } from "@/entities/asset";
import { capitalize } from "@/utilities/string";

const AssetTheoricalRemainingLifespan = ({
  asset,
}: AssetTheoricalRemainingLifespanProps) => {
  const remainingLifespan = getAssetTheoricalRemainingLifespan(asset);

  if (!remainingLifespan) return null;

  return (
    <Tooltip
      title={
        <>
          <CalendarOutlined />
          &nbsp;{remainingLifespan.date}
        </>
      }
    >
      {capitalize(remainingLifespan.text)}
    </Tooltip>
  );
};

export default AssetTheoricalRemainingLifespan;
